import { isRSAA, RSAA } from 'redux-api-middleware';

const createParamReplaceMiddleware = (selectors = {}) => store => next => action => {
  if (!isRSAA(action)) {
    return next(action);
  }

  const storeState = store.getState();
  const endpoint = Object.keys(selectors).reduce(
    (curEndpoint, selectorKey) =>
      curEndpoint.replace(selectorKey, selectors[selectorKey](storeState)),
    action[RSAA].endpoint
  );

  return next({
    ...action,
    [RSAA]: {
      ...action[RSAA],
      endpoint
    }
  });
};

export default createParamReplaceMiddleware;
